import Vue from 'vue'
import http from './httpList';
var stort = function(num,params){
    var index_root = sessionStorage.getItem('index_root');
    return new Promise((resolve,reject)=>{
        if(index_root&&index_root!='undefined'&&num!=1){
            var data = JSON.parse(index_root)
            resolve(data)
        }else{
            http.getHttp({name:'indexList',params:params},(data)=>{
                sessionStorage.setItem('index_root',JSON.stringify(data.data))
                resolve(data.data)
            })
        }
    })
}
export default stort



// WEBPACK FOOTER //
// ./src/api/stort.js